import {parsePhoneNumber} from "awesome-phonenumber";
import moment from "moment-timezone";
import isEmail from "validator/lib/isEmail";

/**
 * Validator which requires a non-empty input.
 */
export const required =
  (msg?: string) =>
  (input?: string): string | undefined => {
    if (!input) {
      if (msg) {
        return msg;
      }
      return "";
    }
    return undefined;
  };

export const requireEmail =
  (msg: string) =>
  (input: string): string | undefined => {
    if (!isEmail(input)) {
      return msg;
    }
    return undefined;
  };

export const validateDate =
  (msgs?: string[]) =>
  (input: string): string | undefined => {
    if (!input) {
      if (!msgs) return "";
      return msgs[0];
    }
    const date = moment(input, "MM/DD/YYYY", true);
    const dateNow = moment(new Date());

    if (!date.isValid()) {
      if (!msgs) return "";
      return msgs[1];
    }

    if (date.isAfter(dateNow)) {
      if (!msgs) return "";
      return msgs[2];
    }

    return undefined;
  };

export const validatePhoneNumber =
  (msg: string) =>
  (num: string, regionSlug: string): string | undefined => {
    if (num && typeof num === "string") {
      const phoneNum = parsePhoneNumber(num, regionSlug);
      const isValid = phoneNum.isValid();

      if (!isValid) {
        return msg;
      }
      return undefined;
    }
  };
